import type { RouteObject } from 'react-router';

import { privateMiddleware } from './private-middleware';
import { clientRoutes } from './client';
import { tenantRoutes } from './tenant';
import { sharedRoutes } from './shared';

export const privateRoutes: RouteObject = {
  middleware: [privateMiddleware],
  children: [clientRoutes, tenantRoutes, sharedRoutes],
};
